"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlWithContextAsQuery = exports.notNullOrUndefined = void 0;
var notNullOrUndefined = function (_a) {
    var value = _a[1];
    return value !== undefined && value !== null;
};
exports.notNullOrUndefined = notNullOrUndefined;
var urlWithContextAsQuery = function (url, context) {
    var urlWithQuery = new URL(url.toString());
    // Add context information to url search params. If the properties
    // object is included in the context, flatten it into the search params
    // e.g. /?...&property.param1=param1Value&property.param2=param2Value
    Object.entries(context)
        .filter(exports.notNullOrUndefined)
        .forEach(function (_a) {
        var contextKey = _a[0], contextValue = _a[1];
        if (contextKey === 'properties' && contextValue) {
            Object.entries(contextValue)
                .filter(exports.notNullOrUndefined)
                .forEach(function (_a) {
                var propertyKey = _a[0], propertyValue = _a[1];
                return urlWithQuery.searchParams.append("properties[".concat(propertyKey, "]"), propertyValue);
            });
        }
        else {
            urlWithQuery.searchParams.append(contextKey, contextValue);
        }
    });
    return urlWithQuery;
};
exports.urlWithContextAsQuery = urlWithContextAsQuery;
//# sourceMappingURL=util.js.map